document.addEventListener("DOMContentLoaded", () => {
  /* -----------------------------------------------------------
     DOM SELECTORS
  ----------------------------------------------------------- */
  const bubble = document.getElementById("tp-ai-bubble");
  const panel = document.getElementById("tp-ai-panel");
  const closeBtn = document.getElementById("tp-ai-close");
  const messagesBox = document.querySelector(".tp-ai-messages");
  const input = document.getElementById("tp-ai-input");
  const sendBtn = document.getElementById("tp-ai-send");
  const progressBar = document.getElementById("tp-ai-progress");

  if (!bubble || !panel || !messagesBox) return;

  /* -----------------------------------------------------------
     API ENDPOINTS (v2)
  ----------------------------------------------------------- */
  const API_CHAT = "https://toldprint-ai-v2.vercel.app/api/chat";

  let autoScroll = true;
  let conversation = [];
  let sending = false;

  /* -----------------------------------------------------------
     UTILITIES
  ----------------------------------------------------------- */
  const smoothScroll = () => {
    setTimeout(() => {
      if (autoScroll) {
        messagesBox.scrollTo({
          top: messagesBox.scrollHeight,
          behavior: "smooth",
        });
      }
    }, 40);
  };

  const typingIndicatorOn = () => {
    const el = document.createElement("div");
    el.id = "tp-typing";
    el.className = "tp-dots";
    el.innerHTML =
      '<div class="tp-dot"></div><div class="tp-dot"></div><div class="tp-dot"></div>';
    messagesBox.appendChild(el);
    smoothScroll();
  };

  const typingIndicatorOff = () => {
    const el = document.getElementById("tp-typing");
    if (el) el.remove();
  };

  const startProgress = () => {
    progressBar.style.display = "block";
    progressBar.style.opacity = "1";
    progressBar.style.width = "0%";
    let v = 0;
    progressBar._int = setInterval(() => {
      v += 5;
      if (v > 90) v = 90;
      progressBar.style.width = v + "%";
    }, 120);
  };

  const stopProgress = () => {
    if (progressBar._int) clearInterval(progressBar._int);
    progressBar.style.width = "100%";
    setTimeout(() => {
      progressBar.style.opacity = "0";
      setTimeout(() => (progressBar.style.width = "0%"), 200);
    }, 200);
  };

  const sanitize = (text) =>
    text.replace(/\n{2,}/g, "\n").replace(/\n/g, "<br>").trim();

  /* -----------------------------------------------------------
     LINK LABELING
     Never show raw URLs — always show clickable text
  ----------------------------------------------------------- */
  const LINK_LABEL_MAP = {
    "/pages/faq": "FAQ",
    "/pages/policies-shipping-policy": "Shipping Policy",
    "/pages/policies-refund-policy": "Refund & Returns Policy",
    "/pages/size-guide": "Size Guide",
    "/pages/care-instructions": "Care Instructions",
    "/pages/about": "About ToldPrint",
    "/pages/ambassador-program": "Ambassador Program",
    "/pages/sustainability": "Sustainability",
    "/blogs/toldprint-stories": "ToldPrint Stories",
    "/pages/contact": "Contact",
    "/pages/licensing": "Licensing",
    "/pages/policies-privacy-policy": "Privacy Policy",
    "/pages/policies-terms-of-service": "Terms of Service",
    "/pages/legal-notice": "Legal Notice",
  };

  const prettyLinkText = (url) => {
    try {
      const u = new URL(url);
      const path = u.pathname.replace(/\/+$/, "");
      if (LINK_LABEL_MAP[path]) return LINK_LABEL_MAP[path];

      const last = path.split("/").filter(Boolean).pop() || "Open page";
      const cleaned = decodeURIComponent(last)
        .replace(/[-_]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();

      return cleaned
        .split(" ")
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");
    } catch {
      return "Open page";
    }
  };

  /* -----------------------------------------------------------
   SAFE LINK RENDER PIPELINE (INLINE)
   - No raw URLs shown
   - Markdown links protected by placeholders
   - All links rendered inline so bullets align
----------------------------------------------------------- */
const extractMarkdownLinks = (html) => {
  const placeholders = [];
  const withTokens = html.replace(
    /\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g,
    (_m, label, url) => {
      const token = `__TPLINK_${placeholders.length}__`;
      placeholders.push(
        `<span class="tp-link" data-url="${url}" style="color:var(--tp-accent);font-weight:600;display:inline;">${label}</span>`
      );
      return token;
    }
  );
  return { withTokens, placeholders };
};

const restorePlaceholders = (html, placeholders) =>
  html.replace(/__TPLINK_(\d+)__/g, (_m, i) => placeholders[Number(i)] || "");

const renderMessage = (role, text) => {
  const div = document.createElement("div");
  div.className = "tp-msg";
  div.classList.add(role === "user" ? "user-block" : "assistant-block");
  div.style.textAlign = role === "user" ? "right" : "left";

  let html = sanitize(text);

  // Links header as its own block with spacing
html = html.replace(
  /(?:<br>\s*)?(Χρήσιμοι σύνδεσμοι:|Useful links:)/g,
  `<div class="tp-links-title" style="margin:6px 0 0 0;font-weight:700;line-height:1.2;">$1</div>`
);


  // 1) Markdown links -> placeholders (inline)
  const { withTokens, placeholders } = extractMarkdownLinks(html);
  html = withTokens;

  // 2) Raw URLs -> clickable pretty labels (inline, never show URL)
  html = html.replace(
    /(https?:\/\/[^\s<]+)/g,
    (_m, url) => {
      const label = prettyLinkText(url);
      return `<span class="tp-link" data-url="${url}" style="color:var(--tp-accent);font-weight:600;display:inline;">${label}</span>`;
    }
  );

  // 3) Restore placeholders
  html = restorePlaceholders(html, placeholders);

  // 4) Bullet alignment safety (if a <br> sneaks in)
  html = html.replace(/•\s*<br>\s*/g, "• ");
  html = html.replace(/<br>\s*•\s*/g, "<br>• ");

  // Remove any extra <br> right after the links title
html = html.replace(
  /(<div class="tp-links-title"[^>]*>[\s\S]*?<\/div>)\s*<br>\s*/g,
  "$1"
);

  div.innerHTML = html;
  messagesBox.appendChild(div);
  smoothScroll();
};

  /* -----------------------------------------------------------
     CLICKABLE LINKS (delegation)
     Works for list + carousel titles + policy links
  ----------------------------------------------------------- */
  messagesBox.addEventListener("click", (e) => {
    const link = e.target.closest(".tp-link");
    if (!link) return;

    const url = link.getAttribute("data-url");
    if (url) window.open(url, "_blank", "noopener");
  });

  /* -----------------------------------------------------------
     PRODUCT CAROUSEL RENDERER
     Uses your existing CSS:
     .tp-product-slider, .tp-slider-track, .tp-product-card, arrows
  ----------------------------------------------------------- */
  const renderProductsCarousel = (products) => {
    const hasImages = products.some(p => p.image);
    if (!hasImages) {
      renderProductsList(products);
      return;
    }

    const slider = document.createElement("div");
    slider.className = "tp-product-slider";

    const track = document.createElement("div");
    track.className = "tp-slider-track";

    let index = 0;

    products.forEach((p) => {
      const card = document.createElement("div");
      card.className = "tp-product-card";

      const imgHtml = p.image
        ? `<img src="${p.image}" alt="${(p.title || "ToldPrint product").replace(/"/g, "&quot;")}" loading="lazy">`
        : "";

      card.innerHTML = `
        ${imgHtml}
        <div class="tp-title tp-link" data-url="${p.url || ""}">
          ${p.title || "View product"}
        </div>
      `;

      track.appendChild(card);
    });

    slider.appendChild(track);

    if (products.length > 1) {
      const left = document.createElement("button");
      left.className = "tp-slider-arrow tp-arrow-left";
      left.innerHTML = "‹";

      const right = document.createElement("button");
      right.className = "tp-slider-arrow tp-arrow-right";
      right.innerHTML = "›";

      const update = () => {
        track.style.transform = `translateX(-${index * 100}%)`;
      };

      left.onclick = () => {
        index = (index - 1 + products.length) % products.length;
        update();
      };

      right.onclick = () => {
        index = (index + 1) % products.length;
        update();
      };

      slider.appendChild(left);
      slider.appendChild(right);
    }

    messagesBox.appendChild(slider);
    smoothScroll();
  };

  /* -----------------------------------------------------------
     PRODUCT LIST RENDERER (fallback)
  ----------------------------------------------------------- */
  const renderProductsList = (products) => {
    const list = document.createElement("div");
    list.className = "tp-product-list";

    products.forEach((p) => {
      const item = document.createElement("div");
      item.className = "tp-product-item";
      item.innerHTML = `
        <span class="tp-link" data-url="${p.url || ""}">
          ${p.title || "View product"}
        </span>
      `;
      list.appendChild(item);
    });

    messagesBox.appendChild(list);
    smoothScroll();
  };

  /* -----------------------------------------------------------
     AUTO-SUGGESTIONS
  ----------------------------------------------------------- */
  const autoSuggestions = (query) => {
    const wrap = document.createElement("div");
    wrap.className = "tp-quick-wrap";

    const q = query.toLowerCase();
    let opts = [];

    if (q.includes("hoodie") || q.includes("sweat"))
      opts = ["Unisex Hoodies", "Oversized Fit", "Winter Styles"];
    else if (q.includes("medusa"))
      opts = ["Ancient Revival", "Medusa Collection", "Greek Mythology"];
    else if (q.includes("sea"))
      opts = ["Sea & Solidarity", "Mediterranean Sea", "Marine Ecology"];
    else
      opts = ["Show me hoodies", "Sea & Solidarity", "Ancient Revival"];

    opts.forEach((txt) => {
      const b = document.createElement("div");
      b.className = "tp-quick-btn";
      b.textContent = txt;
      b.onclick = () => {
        input.value = txt;
        sendMessage();
      };
      wrap.appendChild(b);
    });

    messagesBox.appendChild(wrap);
    smoothScroll();
  };

  /* -----------------------------------------------------------
     SEND MESSAGE
  ----------------------------------------------------------- */
  async function sendMessage() {
    if (sending) return;
    sending = true;

    const text = input.value.trim();
    if (!text) {
      sending = false;
      return;
    }

    renderMessage("user", text);
    input.value = "";
    conversation.push({ role: "user", content: text });

    startProgress();
    autoSuggestions(text);
    typingIndicatorOn();

    try {
      const res = await fetch(API_CHAT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          messages: conversation,
          mode: "auto",
        }),
      });

      const data = await res.json();

      typingIndicatorOff();
      stopProgress();

      if (!data || !data.reply) {
        renderMessage("assistant", "I couldn't understand. Please try again.");
        sending = false;
        return;
      }

      renderMessage("assistant", data.reply);
      conversation.push({ role: "assistant", content: data.reply });

      if (Array.isArray(data.products) && data.products.length > 0) {
        renderProductsCarousel(data.products);
      }

    } catch (err) {
      typingIndicatorOff();
      stopProgress();
      renderMessage("assistant", "Connection error. Please try again.");
    }

    sending = false;
  }

  /* -----------------------------------------------------------
     EVENT HANDLERS
  ----------------------------------------------------------- */
  bubble.addEventListener("click", () => {
    panel.style.display = "flex";
    input.focus();
  });

  closeBtn.addEventListener("click", () => {
    panel.style.display = "none";
  });

  sendBtn.addEventListener("click", sendMessage);

  input.addEventListener("keydown", (ev) => {
    if (ev.key === "Enter" && !ev.shiftKey) {
      ev.preventDefault();
      sendMessage();
    }
  });

  messagesBox.addEventListener("scroll", () => {
    autoScroll =
      messagesBox.scrollTop + messagesBox.clientHeight >=
      messagesBox.scrollHeight - 45;
  });
});

